import { PageHead } from "@/components/UI/atoms/PageHead/PageHead";
import { InvoicesTable } from "@/components/UI/organisms/InvoicesTable/InvoicesTable";
import { useInvoices } from "@/hooks/Invoices";
import styles from "./Invoices.module.scss";
import * as React from "react";
import { RosByService } from "@/components/UI/organisms/Charts/RosByService";
import { RosByMonth } from "@/components/UI/organisms/Charts/RosByMonth";
import { useRepairOrders } from "@/hooks/RepairOrders";
import { useWorkInProgress } from "@/hooks/WorkInProgress";

export interface IInvoicesProps {}

export function Invoices(props: IInvoicesProps) {
	const { data: invoices } = useInvoices();
	const { data: openRos, isLoading } = useRepairOrders("invoiced");
	const { data: wips } = useWorkInProgress();
	const repairOrders = React.useMemo(() => {
		return openRos.filter((ro) => wips.find((wip) => wip.roId === ro.wipId));
	}, [wips, openRos]);
	return (
		<div className={styles.invoices}>
			<PageHead pageTitle="Invoices" pageHead="Invoices"></PageHead>
			<div className={styles.chartRow}>
				<div className={styles.chart}>
					<RosByService
						title="Invoiced Request by Type"
						loading={repairOrders.length === 0}
						repairOrders={repairOrders}></RosByService>
				</div>
				<div className={styles.chart}>
					<RosByMonth
						title="Invoiced Status by Month"
						loading={repairOrders.length === 0}
						repairOrders={repairOrders}></RosByMonth>
				</div>
			</div>
			<InvoicesTable invoiceItems={invoices ?? []}></InvoicesTable>
		</div>
	);
}
